import React, { useState } from 'react';
import { Row, Col, FormGroup, Input, Card, Label, Button } from 'reactstrap';
import Select from 'react-select';
import { TabMenu } from 'primereact/tabmenu';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressBar } from 'primereact/progressbar';
import { useMassPrintingResults } from '../../../hooks/micro/useMassPrintingResults';
import { DialogErrorNims } from './DialogErrorNims';
import { DialogLetterhead } from './DialogLetterhead';

export const IndexMassPrintingResults = () => {
    const {
        start_date, end_date, handleInputChange, isDownloading, isButtonDisabled,
        handleSelectValues, listCompanies, id_company, handleSearch, results, handleGenerateLote, lotes,
        activeTab, setActiveTab, isLoading, handlePrintPDF, handleDownloadPDF, visibleDialog, setVisibleDialog, setSelectedLote, selectedLote,
        downloadExcelErrors, optionsStatus, selectedStatus, setSelectedStatus, handleClearBatch, handleClearAllBatches,
        selectedExams, setSelectedExams, searchTerm, setSearchTerm,
        showDialogLetter, setShowDialogLetter, letterhead, setLetterhead, 

    } = useMassPrintingResults();


    // const handleSearchChange = (e) => {
    //     const value = e.target.value;
    //     setSearchTerm(value);
    // };

    const items = [
        { label: 'Generar Lote de Resultados' },
        { label: 'Mis Lotes de Resultados' }
    ];

    const handleTabChange = (e) => {
        setActiveTab(e.index);
    };

    const handleGenerateLoteClick = () => {
        setShowDialogLetter(true);    
    };
    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const allCompleted = lotes.every((row) => {
        const completed = Number(row.completed_work_orders) || 0;
        const errors = Number(row.error_work_orders) || 0;
        const total = Number(row.total_work_orders) || 1;
        return completed + errors >= total;
    });


    const accionsTemplete = (row) => {
        const percentage = Number(row.percentage) || 0;
        const isDisabled = percentage < 100;

        const disabledStyle = {
            backgroundColor: "#d3d3d3",
            color: "#888",
            cursor: "not-allowed",
            opacity: 0.7
        };

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <button
                    size="sm"
                    disabled={isDisabled}
                    title="Imprimir Resultados"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        borderRadius: "4px",
                        backgroundColor: "#46afe5",
                        color: "#fff",
                        ...(isDisabled ? disabledStyle : {})
                    }}
                    onClick={() => handlePrintPDF(row)}
                >
                    <i className="fa fa-print"></i>
                </button>

                <button
                    size="sm"
                    disabled={isDisabled}
                    title="Descargar Resultados"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        borderRadius: "4px",
                        backgroundColor: "#075488",
                        color: "#fff",
                        ...(isDisabled ? disabledStyle : {})
                    }}
                    onClick={() => handleDownloadPDF(row)}
                >
                    <i className="fa fa-download"></i>
                </button>

                <Button
                    color="danger"
                    size="sm"
                    disabled={isDisabled}
                    style={{
                        padding: "2px 6px",
                        height: "28px",
                        fontSize: "0.8rem",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        ...(isDisabled ? disabledStyle : {})
                    }}
                    onClick={() => handleClearBatch(row)}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };
    let typeMenu = localStorage.getItem('menu') === "True";

    return (
        <>
            <Col className={`container-global-zoom ${typeMenu ? "p-3" : ""}`} sm="12" style={{ position: "relative" }}>
                <span
                    style={{
                        position: "absolute",
                        top: `${typeMenu ? "3px" : "-12px"}`,
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#006d97",
                        color: "#fff",
                        padding: "6px 25px",
                        borderRadius: "25px",
                        fontWeight: 700,
                        fontSize: "12px",
                        boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 12px",
                        zIndex: 2,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        cursor: "default"
                    }}
                >
                    Impresión de Resultados
                </span>

                <TabMenu
                    model={items}
                    activeIndex={activeTab}
                    onTabChange={handleTabChange}
                    className="tab-buttons-fullwidth"
                    style={{ marginBottom: "15px", fontSize: "14px" }}
                />

                {activeTab === 0 && (
                    <Card className="shadow-sm border height-equal pricingtable rounded-2 p-2 mb-2"
                        style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", textAlign: "justify" }}>
                        <Row className="justify-content-center text-center">

                            <Col sm="2" className="mb-2 mt-3">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Empresa <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Select
                                    classNamePrefix="select"
                                    name="id_company"
                                    value={id_company}
                                    options={listCompanies}
                                    onChange={(e) => handleSelectValues(e, "id_company")}
                                    placeholder="Seleccione una opción"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            borderColor: "#4aa7e6ff",
                                            borderStyle: "solid",
                                            borderWidth: "1px",
                                            borderRadius: "15px",
                                            height: "35px",
                                            fontSize: "11px",
                                            textAlign: "center"
                                        }),
                                        menu: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Col>

                            <Col sm="2" className="mb-2 mt-3">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de inicio <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <FormGroup>
                                    <Input
                                        style={{
                                            borderColor: "#4aa7e6ff",
                                            borderStyle: "solid",
                                            borderWidth: "1px",
                                            borderRadius: "15px",
                                            height: "35px",
                                            width: "100%",
                                            fontSize: "11px",
                                            textAlign: "center"
                                        }}
                                        type="date"
                                        name="start_date"
                                        value={start_date}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </Col>

                            <Col sm="2" className="mb-2 mt-3">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Fecha Final <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <FormGroup>
                                    <Input
                                        style={{
                                            borderColor: "#4aa7e6ff",
                                            borderStyle: "solid",
                                            borderWidth: "1px",
                                            borderRadius: "15px",
                                            height: "35px",
                                            width: "100%",
                                            fontSize: "11px",
                                            textAlign: "center"
                                        }}
                                        type="date"
                                        name="end_date"
                                        value={end_date}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                            </Col>

                            <Col sm="2" className="mb-2 mt-3">
                                <Label className="f-w-600 f-12 badge badge-light-primary">Estatus</Label>
                                <Select
                                    classNamePrefix="select"
                                    value={selectedStatus}
                                    options={optionsStatus}
                                    onChange={(e) => setSelectedStatus(e)}
                                    placeholder="Seleccione un estatus"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            borderColor: "#4aa7e6ff",
                                            borderStyle: "solid",
                                            borderWidth: "1px",
                                            borderRadius: "15px",
                                            height: "35px",
                                            fontSize: "11px",
                                            textAlign: "center"
                                        }),
                                        menu: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </Col>


                            <Col sm="2" className="mb-2" style={{ top: "40px" }}>
                                <button
                                    onClick={handleSearch}
                                    disabled={isButtonDisabled}
                                    style={{
                                        backgroundColor: isDownloading ? "#f79a21ff" : "#002940",
                                        color: "#fff",
                                        borderRadius: "15px",
                                        padding: "10px",
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        border: "none",
                                        cursor: isButtonDisabled ? "not-allowed" : "pointer"
                                    }}
                                >
                                    {isDownloading && <i className="fa fa-spinner fa-spin mr-1" />}
                                    {isDownloading ? "Cargando....." : "Busqueda"}
                                </button>
                            </Col>

                            <Col sm="2" className="mb-2" style={{ marginTop: "40px" }}>
                                <Input
                                    type="text"
                                    placeholder="Busqueda por NIM"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{
                                        borderColor: "#4aa7e6ff",
                                        borderRadius: "15px",
                                        height: "35px",
                                        fontSize: "11px",
                                        textAlign: "center"
                                    }}
                                />
                            </Col>
                        </Row>

                        <DataTable
                            value={results}
                            paginator
                            rows={10}
                            responsiveLayout="scroll"
                            className="data-table p-datatable-striped p-datatable-sm"
                            rowsPerPageOptions={[10, 50, 100]}
                            emptyMessage={
                                <div className="text-center">
                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin resultados" />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                        Sin resultados.
                                    </p>
                                </div>
                            }
                            loading={isDownloading}
                            selection={selectedExams}
                            onSelectionChange={(e) => setSelectedExams(e.value)}
                            dataKey="nim"
                            globalFilter={searchTerm || null}
                            globalFilterFields={['nim']}
                        >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                            <Column
                                selectionMode="multiple"
                                headerStyle={headerStyle}
                                style={cellStyle}
                                body={(rowData) => null}
                                disabled={(rowData) => rowData.proceso < 100}
                            />
                            <Column field="fecha" header="Fecha" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="nim" header="NIM" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="nombre_paciente" header="Nombre del Paciente" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="sucursal" header="Sucursal" headerStyle={headerStyle} style={cellStyle} />
                            <Column
                                header="Exámenes"
                                headerStyle={headerStyle}
                                style={cellStyle}
                                body={(rowData) => {
                                    const liberados = rowData.num_examenes_liberados || 0;
                                    const total = rowData.num_examenes_total || 0;
                                    const actualizados = rowData.examenes_actualizados_ultima_proceso || 0;

                                    return (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                            <span>{`(${liberados} / ${total})`}</span>
                                            {actualizados !== 0 && (
                                                <i
                                                    className="fa fa-exclamation-triangle"
                                                    style={{ color: "#FFC107", fontSize: "18px", cursor: "default" }}
                                                    title="Este examen se actualizo después de la última impresión"
                                                ></i>
                                            )}
                                        </div>
                                    );
                                }}
                            />
                            <Column field="status" header="Estatus" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="proceso_usuario" header="Usuario" body={(rowData) => rowData.proceso_usuario || "Sin usuario de impresión"} headerStyle={headerStyle} style={cellStyle} />
                            <Column field="proceso_fecha" header="Fecha de impresión" body={(rowData) => rowData.proceso_fecha || "Sin fecha de impresión"} headerStyle={headerStyle} style={cellStyle} />
                        </DataTable>

                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <Button
                                color={isLoading ? "secondary" : "primary"}
                                style={{
                                    width: "16%",
                                    padding: "6px",
                                    fontSize: "14px",
                                    borderRadius: "19px",
                                    background: isLoading ? "#888888" : "#006d97",
                                    border: "none",
                                    cursor: isLoading ? "not-allowed" : "pointer"
                                }}
                                onClick={handleGenerateLoteClick}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin mr-2" /> Cargando...
                                    </>
                                ) : (
                                    "Generar Lote"
                                )}
                            </Button>
                        </div>

                    </Card>
                )}

                {activeTab === 1 && (
                    <Card className="shadow-sm border height-equal pricingtable rounded-2 p-2 mb-2 container-global-zoom"
                        style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", textAlign: "justify" }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "10px" }}>
                            <button
                                onClick={handleClearAllBatches}
                                className="p-button p-button-danger p-button-sm"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    fontSize: "0.85rem",
                                    borderRadius: "8px",
                                    padding: "4px 10px"
                                }}
                            >
                                <i className="pi pi-trash" style={{ fontSize: "1rem" }}></i>
                                Eliminar todos
                            </button>
                        </div>

                        <DataTable
                            value={lotes}
                            paginator
                            rows={10}
                            responsiveLayout="scroll"
                            className="data-table p-datatable-striped p-datatable-sm"
                            rowsPerPageOptions={[10, 50, 100]}
                            emptyMessage={
                                <div className="text-center">
                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin Cotizaciones" />
                                    <br />
                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                        Sin resultados.
                                    </p>
                                </div>
                            }

                        >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="request_date" header="Fecha de solicitud" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="name_company" header="Empresa" body={(rowData) => rowData.name_company || "Sin empresa seleccionada"} headerStyle={headerStyle} style={cellStyle} />
                            <Column
                                header="Rango de fechas de impresión"
                                headerStyle={headerStyle}
                                style={cellStyle}
                                body={(rowData) => {
                                    const from = rowData.from ? rowData.from : "";
                                    const to = rowData.to ? rowData.to : "";
                                    return `${from} - ${to}`;
                                }}
                            />
                            {!allCompleted && (
                                <Column
                                    header="Tiempo estimado"
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                    body={(rowData) => {
                                        const eta = rowData.eta || "—";
                                        const completed = Number(rowData.completed_work_orders) || 0;
                                        const errors = Number(rowData.error_work_orders) || 0;
                                        const total = Number(rowData.total_work_orders) || 1;
                                        const processed = completed + errors;

                                        if (processed >= total) return null;

                                        return (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    fontWeight: "bold",
                                                    color: "#fff",
                                                    fontSize: "12px",
                                                    backgroundColor: "#419fd4ff",
                                                    padding: "4px 10px",
                                                    borderRadius: "12px",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    textAlign: "center",
                                                    minWidth: "50px"
                                                }}
                                            >
                                                {eta}
                                            </span>
                                        );
                                    }}
                                />
                            )}

                            <Column
                                header="Proceso"
                                body={(row) => {
                                    const percentage = Number(row.percentage) || 0;

                                    if (percentage >= 100) {
                                        return (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    fontWeight: "bold",
                                                    color: "#fff",
                                                    fontSize: "12px",
                                                    backgroundColor: "#31b638ff",
                                                    padding: "4px 10px",
                                                    borderRadius: "12px",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    textAlign: "center",
                                                    minWidth: "60px"
                                                }}
                                            >
                                                Terminado
                                            </span>
                                        );
                                    }

                                    return (
                                        <div style={{ position: "relative", textAlign: "center" }}>
                                            <ProgressBar
                                                value={percentage}
                                                showValue={true}
                                                style={{ height: "20px", borderRadius: "10px" }}
                                            />
                                        </div>
                                    );
                                }}

                                headerStyle={headerStyle}
                                style={cellStyle}
                            />


                            <Column
                                header="Errores al generar PDF"
                                headerStyle={headerStyle}
                                style={cellStyle}
                                body={(rowData) => {
                                    const errors = Number(rowData.error_work_orders) || 0;

                                    if (errors === 0) {
                                        return (
                                            <span
                                                style={{
                                                    backgroundColor: "#389cdfff",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                    borderRadius: "12px",
                                                    padding: "4px 10px",
                                                    fontSize: "12px",
                                                    display: "inline-block",
                                                    minWidth: "60px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                Sin errores
                                            </span>
                                        );
                                    }

                                    return (
                                        <span
                                            onClick={() => {
                                                setSelectedLote(rowData);
                                                setVisibleDialog(true);
                                            }}
                                            style={{
                                                backgroundColor: "#dd1f19ff",
                                                color: "#fff",
                                                fontWeight: "bold",
                                                borderRadius: "12px",
                                                padding: "4px 10px",
                                                fontSize: "12px",
                                                display: "inline-block",
                                                minWidth: "60px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                            }}
                                            title="Ver NIMs con error"
                                        >
                                            {errors} error(es)
                                        </span>
                                    );
                                }}
                            />


                            <Column header="Acciones" body={accionsTemplete} headerStyle={headerStyle} style={cellStyle} />
                        </DataTable>
                    </Card>
                )}
            </Col>


            <DialogErrorNims
                {...{
                    visibleDialog, selectedLote, setVisibleDialog, downloadExcelErrors
                }}
            />
            
            <DialogLetterhead
                {
                ...{
                    handleGenerateLote,showDialogLetter, setShowDialogLetter, letterhead, setLetterhead, selectedExams, id_company, start_date, end_date, isLoading
                }
                }
            />
        </>

        
    );
};
